import { useEffect, useState } from "react";
import api, { formatErr } from "../../../lib/api";
import { card, btn, label, inputStyle } from "../roads/_roadsCommon";

/** Ch 24.3 — Export drainage network as EPA SWMM 5 .inp file. */
export default function SWMMExportPanel({ projectId }) {
  const [networks, setNetworks] = useState([]);
  const [networkId, setNetworkId] = useState("");
  const [text, setText] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => { (async () => {
    try {
      const { data } = await api.get(`/projects/${projectId}/drainage/networks`);
      setNetworks(data.networks || []);
      if (data.networks?.[0]) setNetworkId(data.networks[0].id);
    } catch (e) { setErr(formatErr(e?.response?.data?.detail) || String(e)); }
  })(); /* eslint-disable-next-line */ }, []);

  const fetchInp = async () => {
    if (!networkId) return;
    try {
      const r = await api.get(
        `/projects/${projectId}/drainage/networks/${networkId}/swmm.inp`,
        { responseType: "text" });
      setText(typeof r.data === "string" ? r.data : "");
    } catch (e) { setErr(formatErr(e?.response?.data?.detail) || String(e)); }
  };

  const download = () => {
    const blob = new Blob([text], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const name = (networks.find((n) => n.id === networkId)?.name || "rachana").replace(/\s+/g, "_");
    a.href = url; a.download = `${name}.inp`;
    document.body.appendChild(a); a.click();
    document.body.removeChild(a); URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="swmm-export" style={{ display: "grid",
            gridTemplateColumns: "320px 1fr 280px", gap: 8, height: "calc(100vh - 280px)", minHeight: 700 }}>
      <div style={{ ...card, padding: 8 }}>
        <div style={label}>Network</div>
        <select data-testid="swmm-network" style={inputStyle}
          value={networkId} onChange={(e) => setNetworkId(e.target.value)}>
          {networks.map((n) => <option key={n.id} value={n.id}>{n.name}</option>)}
        </select>
        <button data-testid="swmm-fetch" style={{ ...btn, width: "100%", marginTop: 12 }}
          onClick={fetchInp}>Generate .inp</button>
        {text && (
          <button data-testid="swmm-download" style={{ ...btn, width: "100%", marginTop: 8 }}
            onClick={download}>↓ Download .inp</button>
        )}
      </div>

      <div style={{ ...card, padding: 0, overflow: "hidden" }}>
        <div style={{ padding: 6, fontSize: 11, color: "var(--pf-muted)",
                       borderBottom: "1px solid var(--pf-border)" }}>
          {text ? `${text.split("\n").length} lines · ${(text.length / 1024).toFixed(1)} KB`
                  : "Click Generate to preview the EPA SWMM 5 .inp file"}
        </div>
        <pre data-testid="swmm-text" style={{ margin: 0, padding: 12,
              fontSize: 10, lineHeight: 1.4, background: "#0a1220", color: "#9bdcff",
              height: "calc(100% - 32px)", overflow: "auto", fontFamily: "monospace" }}>
          {text || "//  Network not generated yet"}
        </pre>
      </div>

      <div style={{ ...card, padding: 8 }}>
        <div style={label}>How to use</div>
        <p style={{ fontSize: 10, color: "#aaa", lineHeight: 1.6 }}>
          1) Open EPA SWMM 5 (free download).<br />
          2) File → Open → select the .inp file.<br />
          3) Run Run → Run Simulation. Results will show node depths, link flows,
          and a 2-h triangular hyetograph at the design intensity.<br /><br />
          The export includes [JUNCTIONS], [OUTFALLS], [CONDUITS], [XSECTIONS],
          [SUBCATCHMENTS], [SUBAREAS], [INFILTRATION], [TIMESERIES], and
          [COORDINATES] — sufficient for a complete dynamic-wave simulation.
        </p>
        {err && <div style={{ marginTop: 8, color: "#FF8888", fontSize: 11 }}>{err}</div>}
      </div>
    </div>
  );
}
